var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('van-button',{on:{"click":_vm.gotoMarket}},[_vm._v("交易")]),_c('van-button',{on:{"click":_vm.gotoSell}},[_vm._v("出售")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }